import { UserCampaignManagementAPIClient } from '@studyportals/campaign-management-api-interface';
import { SearchUserDto } from '@studyportals/campaign-management-api-interface/src/domain/users/search-users.dto';
import { ModalErrorStates } from '@/models/modal/modal.enum';
import cookieHandler from '@/infrastructure/cookie-handler';
import rollbarOperator from '@/infrastructure/rollbar-operator';
import store from '@/store';

class UserPresenter {
	private client: UserCampaignManagementAPIClient;
	private readonly tokenId: string;
	private readonly limit = 50;

	constructor() {
		this.client = new UserCampaignManagementAPIClient(webpackDefinitions.CAMPAIGN_MANAGEMENT_API_URL);
		this.tokenId = cookieHandler.retrieveTokenIdCookie();
	}

	public async searchUsers(searchTerm: string): Promise<SearchUserDto[]> {
		let result: SearchUserDto[] = [];
		try {
			const response = await this.client.searchUsers(searchTerm, this.tokenId, this.limit);
			result = response.slice(0, 10);
		} catch (e) {
			rollbarOperator.triggerError(e as Error);
			store.mutations.setModalErrorState(ModalErrorStates.SEARCH_RIGHTS_USERS);
		}

		return result.map((item) => ({
			id: item.id,
			name: item.name,
			email: item.email
		}));
	}
}

export default new UserPresenter();
